var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, Typography } from "@mui/material";
var ManifestMapCopyright = function () {
    return _jsx(Box, __assign({ display: "block", p: 2, sx: { clear: "left" } }, { children: _jsxs(Typography, __assign({ variant: "caption" }, { children: ["Map data \u00A9 ", _jsx("a", __assign({ href: "http://osm.org/copyright" }, { children: "OpenStreetMap" }), void 0), " contributors"] }), void 0) }), void 0);
};
export default ManifestMapCopyright;
